export default __webpack_public_path__ + "static/media/icon_selected_.5eb8b020.svg";